import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import GamesReducer from "./reducer_games"
import GameStatesReducer from "./reducer_gamestates"
import SelectedGameReducer from "./reducer_active_game";
import SelectedClueReducer from "./reducer_active_clue";
import ClueIconReducer from "./reducer_clue_icons";
import sessionReducer from './session';
import userReducer from './user';
import statReducer from './reducer_game_stats';
import leaderboardReducer from './reducer_leaderboard';
import allStatsReducer from './reducer_recent_stats';
import reviewReducer from './reducer_reviews';
import reportReducer from './reducer_reports';
import latLonReducer from './reducer_latlon';

// games and clues are our primary state.  SelectedGame is needed to pull off the modal single-field form updates.
//  Otherwise, we just use games map and the current game id (from the page/route/url).
// form is boilerplate for our redux-form implementation.

const rootReducer = combineReducers({
   games: GamesReducer,                // todo: which games?
   gameStates: GameStatesReducer,      // has .byUser and .byGame see below
   selectedGameId: SelectedGameReducer,
   selectedClue: SelectedClueReducer,
   clueIcons: ClueIconReducer,
   sessionState: sessionReducer,
   userState: userReducer,
   gameStats: statReducer,             // gameStats for currently selected game
   leaderboard: leaderboardReducer, // leaderboard for currently selected game
   recentStats: allStatsReducer,       // gameStats for currently selected game
   gameReviews: reviewReducer,         // reviews for currently selected game
   gameReports: reportReducer,         // reports for currently selected game
   latLon: latLonReducer,
   form: formReducer
});

export default rootReducer;

/*
 "gamestates" is all the downloaded game states from Firestore.
 It has two collections, one called "byUser", one called "byGame".  Each is a collection of gameState collections.
 The byUser collection is keyed by userId, each element is a collection of gameStates keyed by gameId.
 The byGame collection is keyed by gameId, each element is a collection of gameStates keyed by userId.
 gameStates.byUser[userId].gameStates[gameId]
           .byGame[gameId].gameStates[userId]

 "clueIcons" is defined on the server.  They are an array of objects of the form: {name:[string], url:[string]}
 */


// WEBPACK FOOTER //
// ./src/reducers/index.js